<template>
  <div>
   
  </div>
</template>

<script>

export default {
  name: "doctor_list",
  data() {
    return {

    }
  },
  components: {

  },
  mounted() {
      let urlstr = window.location.protocol+"//"+window.location.host;
      let queryName = ''
      let id = this.$route.query.id || this.$route.query.yid;
      console.log(id)
      if('yid' in this.$route.query){
        queryName = 'yid';
      }else if('gua' in this.$route.query){
        queryName = 'gua';
        id = 1;
      }else if('sky' in this.$route.query){
        queryName = 'sky';
        id = 1;
      }else{
        queryName = 'id';
      }
      window.location.href = `${urlstr}/static/openMini.html?${queryName}=${id}`
  },
  computed: {
   
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/openMini/openMini.vue